import {
  Backdrop,
  Box,
  Button,
  IconButton,
  Grid,
  Modal,
  Typography,
  FormControlLabel,
  Checkbox,
  Divider
} from "@mui/material";
import { useState, useMemo, useEffect } from "react";
import { BCPXmark } from "../icons/bcp/BCPIcons";
import GenericPicker from "../utilities/GenericPicker";

export default function PrintPairingsModal(props) {
  const { label, event, open, setOpen } = props;

  const printTypes = [{ label: "By Table Number", value: "tableNumber" }];

  if (event?.teamEvent || event?.format?.teamEvent) {
    printTypes.unshift({
      label: "By Team Name",
      value: "teamName"
    });
  } else {
    printTypes.unshift({ label: "By Player Last Names", value: "lastName" });
    printTypes.unshift({ label: "By Player First Names", value: "firstName" });
  }

  const rounds = useMemo(() => {
    const roundsList = event?.rounds && Object?.keys(event.rounds).length
      ? Object.keys(event.rounds).map((round) => ({
          label: `Round ${round}`,
          value: parseInt(round)
        }))
      : [
          {
            label: `Round ${event?.currentRound || 1}`,
            value: event?.currentRound || 1
          }
        ];
    
    if (event?.currentRound && !roundsList.some(r => r.value === event.currentRound)) {
      roundsList.push({
        label: `Round ${event.currentRound}`,
        value: event.currentRound
      });
      roundsList.sort((a, b) => a.value - b.value);
    }
    
    return roundsList;
  }, [event?.rounds, event?.currentRound]);

  const [printType, setPrintType] = useState(null);
  const [round, setRound] = useState(props?.round || null);
  const [submittedOnly, setSubmittedOnly] = useState(false);

  useEffect(() => {
    if (props?.round) {
      setRound(props.round);
    }
  }, [props?.round]);

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "95vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
          }}
        >
          <Grid item xs>
            <Typography variant="h4" component="h2">
              {label || "Print Settings"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9}>
            <GenericPicker
              label="Pairings Sort Type"
              required
              inclAny={false}
              name="sortType"
              list={printTypes}
              value={printType}
              handleChange={(e) => {
                setPrintType(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <GenericPicker
              label="Round Number"
              required
              inclAny={false}
              name="roundNumber"
              list={rounds}
              value={round}
              handleChange={(e) => {
                setRound(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ mt: 1 }} />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              label="Submitted Pairings Only"
              onChange={(e) => {
                setSubmittedOnly(!submittedOnly);
              }}
              control={<Checkbox checked={submittedOnly} />}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              color="success"
              href={`/event/${event.id}/reports?type=${printType}&round=${round}${submittedOnly ? "&submitted=true" : ""}&embed=true`}
              target="_blank"
              disabled={!Boolean(printType) || !Boolean(round)}
            >
              {`View Print Preview`}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
